/* tslint:disable */
import {
  KanvasUser
} from '../index';

declare var Object: any;
export interface InvitationCodeInterface {
  "id": string;
  "issuedAt": Date;
  "issuedTo"?: string;
  "validUntil"?: Date;
  "isTrial": boolean;
  "isActive": boolean;
  "validFrom": Date;
  "kanvasUserId"?: string;
  kanvasUser?: KanvasUser;
}

export class InvitationCode implements InvitationCodeInterface {
  "id": string;
  "issuedAt": Date;
  "issuedTo": string;
  "validUntil": Date;
  "isTrial": boolean;
  "isActive": boolean;
  "validFrom": Date;
  "kanvasUserId": string;
  kanvasUser: KanvasUser;
  constructor(data?: InvitationCodeInterface) {
    Object.assign(this, data);
  }
  /**
   * The name of the model represented by this $resource,
   * i.e. `InvitationCode`.
   */
  public static getModelName() {
    return "InvitationCode";
  }
  /**
  * @method factory
  * @author Jonathan Casarrubias
  * @license MIT
  * This method creates an instance of InvitationCode for dynamic purposes.
  **/
  public static factory(data: InvitationCodeInterface): InvitationCode{
    return new InvitationCode(data);
  }
  /**
  * @method getModelDefinition
  * @author Julien Ledun
  * @license MIT
  * This method returns an object that represents some of the model
  * definitions.
  **/
  public static getModelDefinition() {
    return {
      name: 'InvitationCode',
      plural: 'InvitationCodes',
      path: 'InvitationCodes',
      idName: 'id',
      properties: {
        "id": {
          name: 'id',
          type: 'string'
        },
        "issuedAt": {
          name: 'issuedAt',
          type: 'Date'
        },
        "issuedTo": {
          name: 'issuedTo',
          type: 'string'
        },
        "validUntil": {
          name: 'validUntil',
          type: 'Date'
        },
        "isTrial": {
          name: 'isTrial',
          type: 'boolean',
          default: false
        },
        "isActive": {
          name: 'isActive',
          type: 'boolean',
          default: true
        },
        "validFrom": {
          name: 'validFrom',
          type: 'Date'
        },
        "kanvasUserId": {
          name: 'kanvasUserId',
          type: 'string'
        },
      },
      relations: {
        kanvasUser: {
          name: 'kanvasUser',
          type: 'KanvasUser',
          model: 'KanvasUser',
          relationType: 'belongsTo',
                  keyFrom: 'kanvasUserId',
          keyTo: 'id'
        },
      }
    }
  }
}



// WEBPACK FOOTER //
// ./src/app/shared/sdk/models/InvitationCode.ts